export const TransactionDetailsQuery = `
      success
      message
      transaction {
        id
        transactionCode
        municipalityId
        approvedBy
        approvedDate
        isApproved
        mlsLink
        approvedInfo {
          company
          email
          firstName
          lastName
          phone
        }
        municipalityData {
          name
          logo
          transferDocumentTitle
          waterReading {
            required
            instructions
          }
          TaxCalculations {
            rate
            instructions
          }
          inspection {
            required
            instructions
            allowUsersToUploadDocs
          }
          proofofTaxPayment {
            required
            instructions
          }
          qualifyingExemptions {
            id
            exemption
          }
        }
        titleCompany
        titleCompanyId
        titleCompanyData {
          _id
          name
        }
        creator {
          type
          firebaseId
          user {
            firstName
            lastName
            company
            email
            phone
          }
        }
        transactionDocuments {
          docUniqueId
          documentType
          otherDocumentType
          docContentType
          firebaseId
          title
          notes
          docUrl
          docKey
          uploadedDate
          uploadedBy
        }
        transactionPayments {
          _id
          transactionId
          firebaseId
          userEmail
          paymentStatus
          paidAmount
          paymentMethodsIdorPaymentId
          stripePaymentId
          cardType
          cardBrand
          cardHolderName
          dateofPayment
          cardEnding
          costItem
          cost
        }
        property {
          type
          location
          address
          city
          state
          zipCode
          longitude
          latitude
          purchasePrice
          closingDate
          notes
        }
        buyers {
          name
          address
          email
          phone
        }
        sellers {
          name
          address
          email
          phone
        }
        activityLog {
          firebaseId
          user {
            firstName
            lastName
            company
            email
            phone
          }
          item
          title
          description
          date
          status
        }
        assignmentChecklist {
          legalDescription {
            firebaseId
            status
            completedAt
            userType
            notes
            user {
              firstName
              lastName
            }
          }
          verifyTaxCalculations {
            firebaseId
            status
            docSrc
            docName
            userType
            completedAt
            user {
              firstName
              lastName
            }
            taxAmount
            verified
            exemption {
              reasons {
                id
                checked
                exemption
              }
              details
              exemptionDocuments {
                name
                src
                uploadedDate
              }
            }
          }

          waterReading {
            firebaseId
            status
            docSrc
            docName
            userType
            completedAt
            isFinalReadingAvailNow
            isFinalReadingRequested
            dateForFinalReading
            readingDocuments {
              name
              src
              uploadedDate
            }
            user {
              firstName
              lastName
            }
          }
          inspection {
            firebaseId
            status
            docSrc
            docName
            userType
            completedAt
            user {
              firstName
              lastName
            }
            inspectionNotes
            inspectionDocuments {
              name
              src
              uploadedDate
            }
          }

          additionalQuestions {
            firebaseId
            status
            userType
            completedAt
            user {
              firstName
              lastName
            }
            answers {
              question
              questionId
              answer
              answeredDate
            }
          }
          proofofTaxPayment {
            firebaseId
            status
            docSrc
            docName
            userType
            completedAt
            user {
              firstName
              lastName
            }
            taxPaymentReceiptNumber
            dateofTaxPayment
            proofofTaxPaymentDocuments {
              name
              src
              uploadedDate
            }
          }
        }
        status
        updatedAt
        createdAt
        pendingTasks
        creator {
          type
          firebaseId
        }
        createdUserData {
          firstName
          lastName
        }
        professionalUsers {
          type
          firebaseId
          key
          profUserTypeId
          user {
            firstName
            lastName
            company
            email
            phone
            firebaseId
          }
        }
      }
    `;
